export class ApiKeyView {
    
    constructor(
        public id: string,
        public displayName: string,
        public permissions: string[],
        public dateCreated: Date
    ) { }
}
